import { graphql } from "../../../services/wp.api.service";

const query = `
mutation ChangePassword($password: String!, $email: String = "") {
	changeUserEmail(input: {email: $email, password: $password}) {
	  message
	  success
	}
}
`;

export const changeMyEmailMutation = (useMutation, options) => useMutation(
	["change_email"],
	(variables) => graphql({
		query,
		variables
	}).
		then(({ data }) => {
			if (data.errors) {
				throw new Error(data.errors[0].message);
			}

			return data?.data?.changeUserEmail;
		}),
	{ ...options }
);
